export default __webpack_public_path__ + "static/media/item_7_active.57f4e1a8.png";